export const getPercentageValue = (value = 0): number => Number((value * 100).toFixed(2));
